/* eslint-disable */
import * as Types from '../../../../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserMenuQueryQueryVariables = Types.Exact<{ [key: string]: never }>;

export type UserMenuQueryQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    username: string;
    team?: { __typename?: 'Team'; id: string; name?: string | null } | null;
    teamMembership?: {
      __typename?: 'UserTeamMembership';
      id: string;
      isEnterprise: boolean;
      isAdmin: boolean;
      memberType: Types.TeamMemberType;
    } | null;
    language: { __typename?: 'Language'; id: string; code: string };
    features: {
      __typename?: 'UserFeatureSet';
      liteLibraryEnabled: boolean;
      plansBenchmarksEnabled: boolean;
    };
    preferences: {
      __typename?: 'UserPreferenceSet';
      paidBenchmarksEnabled: boolean;
    };
    linkedIdentities?: {
      __typename?: 'LinkedIdentities';
      totalCount: number;
    } | null;
  } | null;
};

export const UserMenuQueryDocument = gql`
  query userMenuQuery {
    user {
      id
      username
      team {
        id
        name
      }
      teamMembership {
        id
        isEnterprise
        isAdmin
        memberType
      }
      language {
        id
        code
      }
      features {
        liteLibraryEnabled
        plansBenchmarksEnabled
      }
      preferences {
        paidBenchmarksEnabled
      }
      linkedIdentities {
        totalCount
      }
    }
  }
`;

/**
 * __useUserMenuQueryQuery__
 *
 * To run a query within a React component, call `useUserMenuQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMenuQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMenuQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserMenuQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserMenuQueryQuery,
    UserMenuQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserMenuQueryQuery, UserMenuQueryQueryVariables>(
    UserMenuQueryDocument,
    options
  );
}
export function useUserMenuQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserMenuQueryQuery,
    UserMenuQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserMenuQueryQuery, UserMenuQueryQueryVariables>(
    UserMenuQueryDocument,
    options
  );
}
export type UserMenuQueryQueryHookResult = ReturnType<
  typeof useUserMenuQueryQuery
>;
export type UserMenuQueryLazyQueryHookResult = ReturnType<
  typeof useUserMenuQueryLazyQuery
>;
export type UserMenuQueryQueryResult = Apollo.QueryResult<
  UserMenuQueryQuery,
  UserMenuQueryQueryVariables
>;
